// Libs
import clsx from "clsx";
import type React from "react";

// Utils
import { useIsScrolled } from "src/design-system/core/hooks/useIsScrolled";
import { wrapLabel } from "../../core/utils";

export function CardWithScroll(props) {
    return <div>{props.children}</div>;
}

export interface CardContentProps extends React.PropsWithChildren<unknown> {
    /**
     * Additional className for content
     */
    className?: string;
    /**
     * no padding
     */
    noPadding?: boolean;
    /**
     *  Padding with scroll
     */
    scrollClassName?: string;
    /**
     * full height
     */
    fullHeight?: boolean;
}
export function CardContent({
    children,
    className,
    fullHeight,
    noPadding = false,
    scrollClassName,
    ...otherProps
}: CardContentProps): JSX.Element {
    const { isScrollable, ref } = useIsScrolled();

    const contentClassName = clsx("ds-c-card__content", className, {
        "ds-c-card__content--no-padding": noPadding,
        "ds-c-card__content--full-height": fullHeight,
        [scrollClassName]: isScrollable,
    });

    const wrappedChild = wrapLabel(children);

    return (
        <div ref={ref} className={contentClassName} {...otherProps}>
            {wrappedChild}
        </div>
    );
}
